// @ts-nocheck
import AppConfigs from "configs/env";
import { END_POINTS } from "constants/apiUrl";
import { APIUtils } from "utils";
export const validateCampaignApi = async (payload) => {
  return await APIUtils.get(END_POINTS.VALIDATE_CAMPAIGN, {
    params: payload,
  });
};

export const validateCodeApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_CODE + `/${payload}`, {
  
  });
};

export const OTPLogApi = (payload) => {
  return APIUtils.post(END_POINTS.OTP_LOG_URL, {
    body: payload,
  });
};

export const requestOTPApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_OTP, {
    body: payload,
  });
};

export const verifyOTPApi = (payload) => {
  return APIUtils.post(END_POINTS.VERIFY_OTP, {
    body: payload,
  });
};

export const requestLoginApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_LOGIN_URL, {
    body: payload,
  });
};

export const updateUserInfoApi = (payload) => {
  return APIUtils.post(END_POINTS.UPDATE_USER_INFO_URL, {
    body: payload,
  });
};

export const requestGigyaApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_GIGYA_URL, {
    body: payload,
  });
};
export const checkTransactionIdApi = async (payload) => {
  return await APIUtils.get(`${END_POINTS.CHECK_TRANSACTION_ID}?transactionId=${payload.transactionId}`);
};
export const generateTransactionIdApi = async (payload) => {
  return await APIUtils.get(`${END_POINTS.GENERATE_TRANSACTION_ID}?isOffline=${payload.isOffline}`);
};
export const checkPhoneNumberApi = async (payload) => {
  return await APIUtils.get(`${END_POINTS.CHECK_PHONE_NUMBER}?phoneNumber=${payload.phoneNumber}`);
};
export const receivedReportApi = async (payload) => {
  return await APIUtils.post(`${END_POINTS.RECEIVED_REPORT}`, {
    body: payload
  });
};

